import { render, staticRenderFns } from "./AcademySelector.vue?vue&type=template&id=4e1e3899&scoped=true&"
import script from "./AcademySelector.vue?vue&type=script&lang=js&"
export * from "./AcademySelector.vue?vue&type=script&lang=js&"
import style0 from "./AcademySelector.vue?vue&type=style&index=0&id=4e1e3899&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e1e3899",
  null
  
)

export default component.exports